// React
import React, { useEffect, useState } from 'react';
import {
    Col, ListGroup, Modal, Row
} from 'react-bootstrap';
import { RiDeleteBinLine, RiEditLine, RiInformationLine } from 'react-icons/ri';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// Internal
import { updateBooking } from 'stores/actions';
import { editBooking } from 'services/booking';
import ProductModal from 'components/shared/organisms/ProductModal/ProductModal';
import Booking from 'models/Booking';
// Image
import spinner from 'assets/icons/spinner.svg';
// Styles
import './styles.scss';
import Vet from 'models/Vet';

/**
 * @param {Object} props.show - Style to applied to the component, this overwrites the height and width props
 * @param {Function} props.onHide - Path or Route object to navigate to
 * @param {boolean} props.divider - Boolean to display the divider between header and body, default is true.
 * @param {Object} props.style - Style to applied to the component, this overwrites the height and width props
*/
const ShoppingCartModal = (props) => {
    const [ pricingOption, setPricingOption ] = useState(null);
    const [ isLoading, setIsLoading ] = useState(0);
    const [ loadingItemId, setLoadingItemId ] = useState(null);
    const [ productModalEnabled, setProductModalEnabled ] = useState(0);
    const [ productItem, setproductItem ] = useState(null);
    const [ isEdit, setIsEdit ] = useState(0);
    // const [ price, setPrice ] = useState(0);

    /**
     * Remove the item selected from the item list
     * @param {number} itemId the id of the item selected
     */
    const removeItem = async (itemId) => {
        // set loading and loading item Id
        setIsLoading(1);
        setLoadingItemId(itemId);
        const booking = { ...props.booking };
        const index = booking.quotedProducts.filter((item) => {
            return item.id === itemId || item.parentProductId === itemId
        } );

        index.forEach((value, index) => {
            const filteredProduct = booking.quotedProducts.find(x => x.id === value.id)
            filteredProduct.deleted = 1;
            filteredProduct.quantity = 0;
        });
            // Bookings already created can be updated
            if (booking.id) {
                try {
                    await editBooking(booking.id, booking.submitFormat()).then(async (response) => {
                        await props.updateBooking(Booking(response.data));
                        // unset loading
                        setIsLoading(0);
                        setLoadingItemId(null);
                    })

                } catch (error) {
                    console.log(error)
                }
            } else {
                // unset loading
                setIsLoading(0);
                setLoadingItemId(null);
                // New Bookings (Vet supply)
                await props.updateBooking(booking);
            }
    };

    const itemPriceStr = (item) => {
        if (!item) {
            return ``;
        }

        let strNumber = item.unitPrice
        let isUnitPriceANumber = typeof strNumber == 'string';
        let convertToInt = 0;

        if (isUnitPriceANumber) {
            // Remove the digit after the (.)
            let cleanNumber = strNumber.split('.')[0].replace(/,/g, "");
            // Parse to Int
            convertToInt = parseInt(cleanNumber.replace(/[,\.]/g, ""), 10);
        } else {
            convertToInt = strNumber;
        }

        const price = parseFloat(item.quantity) * parseFloat(convertToInt);

        return `$${price.toFixed(2)}`;
    };

    useEffect(() => {
        if (props.vetDetails) {
            const vet = Vet(props.vetDetails);

            setPricingOption(vet.getPricingOption());
        }
    }, [props.vetDetails]);

    const viewProductDetails = (product,isEdit) => {
        setIsEdit(isEdit)
        setProductModalEnabled(1);
        setproductItem(product)
    }

    const hideProductDetails = () => {
        setProductModalEnabled(0);
    }

    return (
                <div className="content">
                    <Row className="header-row">
                        <Col><h5>Items</h5></Col>
                        { pricingOption !== 'No price' ? <Col><p className='label label-price'>{ pricingOption }</p ></Col> : null }
                    </Row>
                    <hr />

                    <ProductModal
                        show={productModalEnabled}
                        onHide={hideProductDetails}
                        isEdit={isEdit}
                        product={productItem}
                    />
                    <ListGroup>
                        {
                            props.items.map((item) => (

                                <ListGroup.Item key={item.id}>

                                    <Row>
                                        <Col>

                                            {item.canBeDeleted  ?
                                                // check if loading
                                                (isLoading && loadingItemId == item.id) ? (
                                                    <img
                                                        className="loading-icons"
                                                        alt="loading-icon"
                                                        src={spinner}
                                                    />
                                                ) : <div id='function-button'><RiDeleteBinLine
                                                className="delete-icon"
                                                size="18"
                                                style={{ marginTop: '-9px' }}
                                                onClick={() => { removeItem(item.id); }}
                                                />
                                                {/* TEMPORARILY COMMENTED TO REMOVE 1318 CHANGES
                                                <RiEditLine
                                                className="delete-icon"
                                                size="18"
                                                style={{ marginTop: '-9px' }}
                                                onClick={() => {
                                                    viewProductDetails(item,true)
                                                } }
                                                /> */}
                                                </div>
                                                : ''
                                            }
                                        </Col>
                                        <Col>
                                            <p className="label">{item.name}</p>
                                            {
                                                item.childProductsCartFormat.map((childProduct, intChildIndex) => childProduct.showInConfirmationEmail ? <p className="label label-secondary label-indented" key={intChildIndex}>{childProduct['name']}</p> : '')
                                            }
                                            {/* TEMPORARILY COMMENTED TO REMOVE 1318 CHANGES
                                            {item.canBeDeleted && item.isVpcreated  ?
                                                // check if loading
                                                (isLoading && loadingItemId == item.id) ? '' : '' :
                                                <p style={{ color: '#FF0000'  }}>To delete or edit these items, please contact our Client Care team.</p>
                                            }
                                            */}
                                        </Col>
                                        <Col>
                                            <p className="label">
                                                { pricingOption !== 'No price' ? itemPriceStr(item) : null }
                                            </p>
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                            ))
                        }
                    </ListGroup>
                    <Row className="collection-travel-cost-row">
                        <Col xs={9} sm={9} md={9} lg={9} className="label">Collection Travel Cost</Col>
                        {
                            pricingOption !== 'No price' ?
                            <Col xs={3} sm={3} md={3} lg={3} >
                                <p className="label label-price">{ `$${props.booking.collection_fee.toFixed(2)}` ?? '$0.00' }</p>
                            </Col> : null
                        }
                    </Row>
                    <Row className="return-travel-cost-row">
                        <Col xs={9} sm={9} md={9} lg={9} className="label">Return Travel Cost</Col>
                        {
                            pricingOption !== 'No price' ?
                            <Col xs={3} sm={3} md={3} lg={3} >
                                <p className="label label-price">{ `$${props.booking.return_fee.toFixed(2)}` ?? '$0.00' }</p>
                            </Col> : null
                        }
                    </Row>
                    <hr />
                    <Row className="total-container">                        {
                            pricingOption !== 'No price' ?
                            <Col>
                                <p className="label label-price"><span className='label-total'>Total (inc GST)</span> { !pricingOption !== 'No price' ? `$${props.totalPrice}` : '$0.00' }</p>
                            </Col> : null
                        }

                    </Row>
                </div>
    );
};

const mapStateToProps = (state) => ({ booking: state.booking });

const mapDispatchToProps = (dispatch) => {
    return {
        updateBooking: (bookingObj) => dispatch(updateBooking(bookingObj))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShoppingCartModal));
